import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import { emptyStringIfNull } from '../General/Helper'
import ReactModal from "react-modal";
import { isNullOrUndefined } from 'util';
import { AbconetApi } from '../General/AbconetApi';


export class ProfileEdit extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isSaved: true,
            isSaving: false,
            success: false,
            message: "",
            passwordError: false,
            passwordErrorMessage: '',
            submittedValues: this.props.initialState
        }
    }

    componentDidMount() {
    }

    handleCurrentPasswordChange(evt) {
        this.setState({ currentPassword: evt.target.value });
    }
   
    sendStateToServer() {
        var self = this;

        AbconetApi.post('/api/user/profileupdate', this.state.submittedValues).then(response => {
            setTimeout(() => {
                self.setState({ isSaved: true, errorMessage: "", isSaving: false });
            }, 1000);

        });
    }

    submitProfile(submittedValues) {
        //if (isNullOrUndefined(submittedValues.name) || submittedValues.name === '') {
        //    alert('Name is required');

        //    return;
        //}

        //if (isNullOrUndefined(submittedValues.email) || submittedValues.email === '') {
        //    alert('Email is required');

        //    return;
        //}

        AbconetApi.post(`/api/user/login`, { username: submittedValues.email, password: submittedValues.currentPassword }).then((data) => {
            if (!data.success) {
                this.setState({ passwordError: true, passwordErrorMessage: 'Current password did not matched' });
                return;
            }
        });

        if (submittedValues.password != submittedValues.confirmPassword) {
            this.setState({ passwordError: true, passwordErrorMessage: 'Password did not matched' });
            return;
        }

        if (submittedValues.password === '' && submittedValues.confirmPassword === '') {
            this.setState({ passwordError: true, passwordErrorMessage: 'Please enter a password' });
            return;
        }

        if (submittedValues.password.length <= 4) {
            this.setState({ passwordError: true, passwordErrorMessage: 'Password length must be five(5) characters or more.' });
            return;
        }

        this.setState({ submittedValues, message: '', passwordError: false, isSaving: true }, this.sendStateToServer);
    }

    renderSaveButton() {

        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }
        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }

    setChange(data) {
        this.setState({ isSaved: false });
    }

    renderpasswordError() {
        if (this.state.passwordError === true) {
            return <div className="alert alert-danger">
                <h5> {this.state.passwordErrorMessage}</h5>
            </div>;
        }
    }

    render() {
       
        return (
            <div>
                {this.renderpasswordError()}
                <h4>Edit Profile</h4>
                <Form
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.submitProfile.bind(this)} defaultValues={this.state.submittedValues}>
                    {formApi => {
                        this.formApi = formApi;

                        return (
                            <form autoComplete="off" onSubmit={formApi.submitForm} id="dynamic-form">
                                <div className="card-body text-dark">
                                    <div className="form-group row">
                                        <label htmlFor="name" className="col-sm-2">Name</label>
                                        <div className="col-sm-10">
                                            <Text disabled field="name" id="name" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="email" className="col-sm-2">Email</label>
                                        <div className="col-sm-10">
                                            <Text disabled field="email" id="email" className="form-control" />
                                        </div>
                                    </div>                                 
                                                                        
                                    <div className="form-group row">
                                        <label htmlFor="currentPassword" className="col-sm-2">Current Password</label>
                                        <div className="col-sm-10">
                                            <Text field="currentPassword" id="currentPassword" className="form-control"  type="password"  />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="password" className="col-sm-2">New Password</label>
                                        <div className="col-sm-10">
                                            <Text field="password" id="password" className="form-control" type="password" />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="confirmPassword" className="col-sm-2">Confirm Password</label>
                                        <div className="col-sm-10">
                                            <Text field="confirmPassword" id="confirmPassword" className="form-control" type="password" />
                                        </div>
                                    </div>
                                    {this.renderSaveButton()}
                                </div>
                            </form>
                        )
                    }}
                </Form>
            </div>
        );
    }

}